<!-- 组件说明 -->
<template>
  <a-drawer
    :width="700"
    :visible="visible"
    :title="status == 0 ? '添加' : '编辑'"
    @ok="addZxBtn"
    @close="handleOk"
  >
    <!-- <div>
      <a-radio-group v-model="value" @change="onChange">
        <a-radio :style="radioStyle" :value="1">
          活&nbsp;&nbsp; 动
        </a-radio>
        <a-radio :style="radioStyle" :value="2">
          资&nbsp;&nbsp;&nbsp;讯
        </a-radio>
      </a-radio-group>
    </div>
    <div>
      <a-radio-group v-model="conValue" @change="onChange2">
        <a-radio :style="radioStyle" :value="1">
          富文本
        </a-radio>
        <a-radio :style="radioStyle" :value="2">
          链&nbsp;&nbsp;&nbsp;接
        </a-radio>
      </a-radio-group>
    </div>
    <a-input v-model="title" placeholder="输入标题"></a-input>
    <a-input v-if="conValue==2" v-model="url" placeholder="输入链接"></a-input> -->

    <a-form-model ref="ruleForm" :model="formData" :rules="rules">
      <a-form-model-item
        label="类型"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        ref="typeValue"
        prop="typeValue"
      >
        <a-radio-group v-model="formData.typeValue" @change="onChange">
          <a-radio :value="1">资讯</a-radio>
          <a-radio :value="2">活动</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="内容"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        ref="conValue"
        prop="conValue "
      >
        <a-radio-group v-model="formData.conValue" @change="onChange2">
          <a-radio :value="1">富文本</a-radio>
          <a-radio :value="2">链接</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        label="标题"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        ref="title"
        prop="title"
      >
        <a-input
          type="text"
          v-model="formData.title"
          placeholder="请填写标题"
        />
      </a-form-model-item>
      <a-form-model-item
        label="富文本"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        v-if="formData.conValue == 1"
      >
        <tinymce-editor
          ref="myQuillEditor"
          :value="formData.content"
          @change="onEditorChange"
          :showUpload="false"
        />
      </a-form-model-item>
      <a-form-model-item
        label="链接"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        v-if="formData.conValue == 2"
      >
        <a-input
          v-if="formData.conValue == 2"
          v-model="formData.url"
          placeholder="输入链接"
        />
      </a-form-model-item>
      <div class="drawer-bootom-button">
        <a-button @click="handleOk" style="margin-right: 0.8rem">取消</a-button>
        <a-button @click="addZxBtn" type="primary">提交</a-button>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addZx, updateZx } from '@api/api';
import tinymceEditor from '@/components/tools/tinymceEditor';
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  ['blockquote', 'code-block'], // 引用  代码块-----['blockquote', 'code-block']
  [
    {
      header: 1
    },
    {
      header: 2
    }
  ], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
  [
    {
      list: 'ordered'
    },
    {
      list: 'bullet'
    }
  ], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  [
    {
      script: 'sub'
    },
    {
      script: 'super'
    }
  ], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  [
    {
      indent: '-1'
    },
    {
      indent: '+1'
    }
  ], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
  [
    {
      direction: 'rtl'
    }
  ], // 文本方向-----[{'direction': 'rtl'}]
  // [{
  //   size: ["small", false, "large", "huge"]
  // }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
  // [{
  //   header: [1, 2, 3, 4, 5, 6, false]
  // }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [
    {
      color: []
    },
    {
      background: []
    }
  ], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  // [{
  //   font: []
  // }], // 字体种类-----[{ font: [] }]
  [
    {
      align: []
    }
  ], // 对齐方式-----[{ align: [] }]
  ['clean'] // 清除文本格式-----['clean']
  // ["image"] // 链接、图片、视频-----['link', 'image', 'video']
];
export default {
  props: ['visible'],
  components: {
    tinymceEditor
  },
  data() {
    return {
      formData: {
        url: '',
        typeValue: 1,
        conValue: 1,
        title: '',
        content: ''
      },
      id: '',
      status: 0,

      form: this.$form.createForm(this),
      rules: {
        title: [{ required: true, message: '请填写标题', trigger: 'blur' }]
      },
      editorOption: {
        //不显示工具栏
        //   theme: 'bubble',
        modules: {
          //工具栏定义的
          toolbar: toolbarOptions
        }
      },
      loading: false,
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      }
    };
  },
  watch: {
    content(newVal) {
      if (newVal) {
        this.formData.conValue = 1;
      }
    },
    url(newVal) {
      if (newVal) {
        this.formData.conValue = 2;
      }
    }
  },
  computed: {},
  mounted() {
    this.formData.title = '';
    this.formData.content = '';
    this.formData.url = '';
    this.formData.typeValue = 1;
    this.formData.conValue = 1;
  },
  methods: {
    addZxBtn() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.status == 0) {
            console.log(333333);
            //  let params = {
            //    type: this.formData.typeValue,
            //    title: this.frmData.title,
            //    content: this.formData.content,
            //    url: this.formData.url,
            //  }
            addZx({
              type: this.formData.typeValue,
              id: this.formData.id,
              title: this.formData.title,
              content: this.formData.content,
              url: this.formData.url
            }).then(res => {
              console.log(677778);
              if (res.success) {
                this.$message.success('添加成功');
                this.$emit('cancle');
                this.formData.title = '';
              } else {
                this.$message.error(res.message);
                this.$emit('cancle');
                this.formData.title = '';
              }
            });
          } else if (this.status == 1) {
            console.log('error!!');

            updateZx({
              type: this.formData.typeValue,
              id: this.formData.id,
              title: this.formData.title,
              content: this.formData.content,
              url: this.formData.url
            }).then(res => {
              if (res.success) {
                this.$message.success('编辑成功');
                this.$emit('cancle');
              } else {
                this.$message.error(res.message);
                this.$emit('cancle');
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onChange(e) {
      console.log(this.formData.typeValue, e);
    },
    onChange2(e) {
      console.log(this.formData.conValue, e);
    },
    handleOk() {
      this.$emit('cancle');
      this.$refs.ruleForm.resetFields();
    },
    onEditorChange(val) {
      this.formData.content = val;
    }
  }
};
</script>

<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
